export const musicMoments = [
  { name: 'Start', value: 'ENTER' },
  { name: 'Reflection', value: 'REFLECTION' },
  { name: 'Committal', value: 'COMMITTAL' },
  { name: 'End', value: 'LEAVE' },
];
